import { HttpClient } from "@angular/common/http";
import { ConfigService } from "src/app/utils/config.service";
import { LayerGroupDTO } from "./model/LayerGroupDTO";
import { Observable, catchError, of, tap } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class MapChartService {
  private apiServer = ConfigService.settings.apiServer;
  private layerGroupUrl = this.apiServer.url + '/aixm/featureSearch';


  constructor(private http: HttpClient) { }

  /** GET all layer groups from the server */
  getAllLayerGroup(workspaceName: string): Observable<LayerGroupDTO[]> {
    const url = `${this.layerGroupUrl}/${workspaceName}/layer-groups`;

    return this.http.get<LayerGroupDTO[]>(url).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError<LayerGroupDTO[]>('getAllLayerGroup', []))
    );
  }

  /**
  * Handle Http operation that failed.
  * Let the app continue.
  * @param operation - name of the operation that failed
  * @param result - optional value to return as the observable result
  */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


}